import { styled, Typography, Grid } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  gap: "20px",
  justifyContent: "space-between",
});

export const BlockContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const Field = styled(Grid)({
  display: "flex",
  gap: "10px",
  alignItems: "baseline",
  "& .MuiTextField-root": {
    width: "300px",
  },
});

export const Label = styled(Typography)(({ theme }) => ({
  width: "105px",
  color: theme.palette.secondary.main,
}));
